/* eslint-disable class-methods-use-this */
import axios from 'axios';

export default class Axios {
	constructor() {
		this.axios = axios.create({
			headers: {
				'Access-Control-Allow-Origin': '*',
			},
		});
	}
}
